'use client';

import { PropsWithChildren, useRef } from 'react';
import { Provider } from 'react-redux';

import { makeStore } from '@/store';

export const ReduxProvider = ({ children }: PropsWithChildren) => {
  const storeRef = useRef<ReturnType<typeof makeStore>>(undefined);

  if (!storeRef.current) {
    storeRef.current = makeStore();
  }

  return <Provider store={storeRef.current}>{children}</Provider>;
};
